import { css } from '@emotion/react';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type RealityCardProps = {
  className?: string;
  index: number;
  head: React.ReactNode;
  comment: React.ReactNode;
  subText: React.ReactNode;
  spImage: React.ImgHTMLAttributes<HTMLImageElement>;
  pcImage: React.ImgHTMLAttributes<HTMLImageElement>;
};

export const RealityCard: React.FC<RealityCardProps> = ({
  className,
  index,
  head,
  comment,
  subText,
  spImage,
  pcImage,
}) => {
  return (
    <div
      css={css`
        padding-left: 20px;
        position: relative;
        z-index: 1;

        @media ${getScreen('pc')} {
          max-width: 1080px;
          margin-right: auto;
          margin-left: auto;
          padding: 0 20px;
          width: 100%;
        }
      `}
      className={className}
    >
      <div
        css={css`
          background: #ffffff;
          box-shadow: 0px 0px 16px #2c28281c;
          border-radius: 16px;
          margin-right: 20px;
          display: grid;
          grid-template-areas:
            'index head'
            'children children';
          grid-template-columns: 56px 1fr;
          grid-template-rows: 92px 1fr;
          gap: 0 16px;
          padding-top: 4px;

          @media ${getScreen('pc')} {
            width: 740px;
            max-width: 72%;
            min-height: 380px;
            grid-template-columns: 81px 1fr;
            grid-template-rows: calc(115px - 40px) 1fr;
            padding: 0;
          }
        `}
      >
        <p
          css={css`
            font: normal normal bold 72px/92px 'din-2014', sans-serif;
            letter-spacing: 0px;
            color: #00b3a7;
            grid-area: index;
            margin-left: 16px;
            text-align: center;

            @media ${getScreen('pc')} {
              font: normal normal bold 90px/115px 'din-2014', sans-serif;
              letter-spacing: 0px;
              margin-left: 32px;
              margin-top: -40px;
            }
          `}
        >
          {index}
        </p>
        <p
          css={css`
            font: normal normal bold 18px/28px 'Noto Sans JP';
            letter-spacing: 0.58px;
            grid-area: head;
            align-self: center;

            @media ${getScreen('pc')} {
              font: normal normal bold 24px/38px 'Noto Sans JP', sans-serif;
              letter-spacing: 1.15px;
              margin-top: calc(30px + -40px);
            }

            strong {
              color: #00b3a7;
              font-weight: inherit;
            }

            br {
              @media ${getScreen('pc')} {
                display: none;
              }
            }
          `}
        >
          {head}
        </p>
        <div
          css={css`
            padding: 16px 24px 24px;
            text-align: center;
            grid-area: children;

            @media ${getScreen('pc')} {
              padding: 4px 20px 32px;
            }
          `}
        >
          <img
            css={css`
              max-width: 100%;
              height: auto;

              @media ${getScreen('pc')} {
                display: none;
              }
            `}
            {...spImage}
            loading="lazy"
          />
          <img
            css={css`
              max-width: 100%;
              height: auto;

              @media ${getScreen('pc', '未満')} {
                display: none;
              }
            `}
            {...pcImage}
            loading="lazy"
          />
        </div>
      </div>
      <div
        css={css`
          position: absolute;
          top: 60px;
          right: 0;
          width: calc(100% - 45px);
          height: calc(100% - 60px + 1px);
          background: #f1fffd;
          z-index: -1;

          @media ${getScreen('pc')} {
            display: none;
          }
        `}
      ></div>
      <div
        css={css`
          background: #f1fffd;
          border-radius: 0 0 0 16px;
          padding: 32px 30px 40px 32px;
          margin-left: 25px;
          position: relative;
          z-index: -1;

          @media ${getScreen('pc')} {
            margin-top: -330px;
            width: 960px;
            max-width: 97%;
            margin-left: auto;
            min-height: 370px;
            padding: 64px 48px 56px;
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            top: -88px;
            right: 48px;

            @media ${getScreen('pc', '未満')} {
              display: none;
            }
          `}
        >
          <p
            css={css`
              position: absolute;
              top: 0;
              right: 0;
              text-align: center;
              width: 165px;
              height: 86px;
              background: #fef8e3;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font: normal normal bold 16px/24px 'Noto Sans JP', sans-serif;
              letter-spacing: 0.64px;
              color: #ff9925;

              &::before {
                position: absolute;
                top: 72px;
                left: 6px;
                content: '';
                display: block;
                width: 38px;
                height: 20px;
                background: #fef8e3;
                clip-path: path(
                  'M18.9487 -0.000488281L-0.000488281 20.3462L37.7456 7.22705L18.9487 -0.000488281Z'
                );
              }
            `}
          >
            {comment}
          </p>
          <div
            css={css`
              position: absolute;
              top: 32px;
              right: 128px;
            `}
          >
            <img
              src={withPrefix('/images/reality-human.png')}
              width="73"
              height="99"
              alt=""
            />
          </div>
        </div>
        <p
          css={css`
            font: normal normal normal 14px/26px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.22px;
            color: #5a5b6a;

            @media ${getScreen('pc')} {
              width: 208px;
              max-width: 25%;
              margin-left: auto;
            }
          `}
        >
          {subText}
        </p>
      </div>
    </div>
  );
};
